/**
 * Shared MUI component styles used across task/todo detail components.
 *
 * These style objects were extracted from SubTaskDetails.tsx and ToDoDetails.tsx
 * to eliminate duplication.
 */

export const sharedSx = {
	"min-width": "160px",
	"& .MuiSelect-select": {
		padding: "9.5px 8px !important",
		// Same reason as `autocompleteSx` below: the shorthand above would otherwise
		// drop the room MUI reserves for the expand arrow, and a long option label
		// would run underneath it.
		paddingRight: "32px !important",
		fontSize: "14px",
		lineHeight: "1.5",
	},
	"& .MuiInputBase-root": {
		marginBottom: "0px",
		borderRadius: "12px",
		fontSize: "14px",
		padding: "0px !important",
	},
	"& .MuiOutlinedInput-root": {
		padding: "0px !important",
	},
	"& .MuiAutocomplete-inputRoot": {
		padding: "8px !important",
	},
	"& .MuiSelect-icon": {
		color: "#11110F",
	},
};

/**
 * `sharedSx` for Autocompletes — apply it to the `<Autocomplete>` itself, not to
 * the `<TextField>` inside `renderInput`.
 *
 * MUI reserves room for the clear and expand buttons with its own `padding-right`
 * on the input root. The blanket `padding: 8px !important` above wipes that, which
 * is how a long value ends up running underneath the ✕. These two rules put the
 * reservation back, sized to the buttons actually rendered — and they only match
 * when the sx sits on the Autocomplete root, because `hasPopupIcon` /
 * `hasClearIcon` are classes on that element.
 */
export const autocompleteSx = {
	...sharedSx,
	"&.MuiAutocomplete-hasPopupIcon .MuiAutocomplete-inputRoot": {
		paddingRight: "36px !important",
	},
	"&.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot": {
		paddingRight: "62px !important",
	},
	"& .MuiAutocomplete-input": {
		textOverflow: "ellipsis",
	},
};

export const sharedInputProps = {
	style: {
		display: "flex",
		alignItems: "center",
		fontSize: "14px",
	},
};

export const sharedMenuProps = {
	PaperProps: {
		sx: {
			padding: "8px",
			marginTop: "4px",
			borderRadius: "12px",
			"& .MuiList-root": {
				margin: "0px",
				padding: "0px",
				gap: "8px",
				display: "flex",
				flexDirection: "column",
			},
			"& .MuiMenuItem-root": {
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
				fontSize: "14px",
				margin: "0px",
				padding: "0px",
				backgroundColor: "transparent !important",
				"&.Mui-selected": {
					color: "#B8431A",
				},
				"&:hover": {
					backgroundColor: "transparent !important",
				},
			},
		},
	},
};
